export default __webpack_public_path__ + "static/media/1883.05766f5a.png";